import * as React from 'react';
export const SASvg = React.forwardRef(function SASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#24B47E',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M12 8h1l-.5 1H12v1l-1-.5V9H5.492L3 8h8v-.5l1-.5v1Zm-1-5 1.657.146L13 4v2h-1l-1.492-.528L10 6V3h1Zm-3 .375L9 3v3l-1-.488L7 6l.172-1.858L7 3l1 .375ZM5 3l1 1v2l-.764-.343L4 6l-.994-.006.183-2.917L5 3Z',
      }),
    ),
  );
});
SASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SA = {
  category: 'flag',
  colorable: false,
  name: 'SA',
  svg: SASvg,
};
